function normalizeCityName(cityName) {
  return cityName.replaceAll('-', '_');
}
export default normalizeCityName;
